import { createFileRoute } from '@tanstack/react-router'

import { ChecksInsightsPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/checks',
)({
  component: () => <ChecksInsightsPage />,
})
